module.exports = __webpack_public_path__ + "img/lockedFunds.c1d4a7c2.jpg";